<template>
    <div>
        <GysInfo v-if="pageFlag" :pageFlag="pageFlag" :key="pageFlag" :gysId="gysId" :showAuditList="showAuditList"/>
    </div>
</template>

<script>
import GysInfo from '../gysInfo'
export default {
    props: {

    },
    data() {
        return {
            pageFlag:'',        
            gysId:'', 
            showAuditList:true,       
        };
    },
    computed: { 
        userInfo:function(){
            return this.$store.getters['user/user'];
        },
    },
    created() {
        // this.gysId = this.$route.params.id;  // 详情id
        console.log(this.$route)
        console.log('-0-0-0-0-0-0-0-0-showAuditInfo')
        if(this.$route.path.indexOf('showgysinfo')>-1){ // 查看详情
            this.pageFlag = 'showGysInfo';
            this.gysId = this.$route.params.id;
            this.showAuditList = false;
        }else if(this.$route.path.indexOf('newgysinfo')>-1){
            this.pageFlag = 'showGysInfo';
            this.gysId = this.$route.params.id;
            this.showAuditList = false;
        }else{
            this.pageFlag = 'showAuditInfo';
            this.gysId = this.$route.params.id;
        }
    },
    methods: {

    },
    components: {
        GysInfo,
    },
};
</script>

<style lang="scss">

</style>
